export const debugLog = console.debug;

export const errorLog = console.error;

export const warnLog = console.warn;
